export default "__VITE_ASSET__DMi$pOxQ__"